import { FC, type ReactElement } from 'react';
import toastErrorIcon from '@assets/images/parrot/toast-error.svg';
import styles from './index.module.scss';

interface OwnProps {
  description: string | ReactElement;
}

const ToastError: FC<OwnProps> = ({ description }) => {
  return (
    <div className={styles.wrapper}>
      <img src={toastErrorIcon} />
      <div>
        <div className={styles.error}>Transaction failed</div>
        <div className={styles.error_des}>{description}</div>
      </div>
    </div>
  );
};

export default ToastError;
